export default __webpack_public_path__ + "static/media/us_3.66571c81.mp3";